



















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import GroupBookingJson from "../../shared/GroupBookingJson";

export default Vue.extend({
  name: "DialogCancelBooking",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    data: Object,
    validation: Object,
    validated: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      detailsTitle: "Anfrage/Buchung absagen",
      details: null as GroupBookingJson | null,
      storedDetails: null as any,
      toValidate: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.storedDetails = { ...this.data };
      this.details = this.data;
    },

    cancelDialog() {
      this.$emit("cancelDialog", this.storedDetails);
    },

    inputValidation(key: any, prop: any) {
      this.$emit("inputValidation", key, prop);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      this.$emit("removeValidationHint", key, prop);

      this.$forceUpdate();
    },

    cancelBooking() {
      this.$emit("cancelBooking");
    },
  },

  watch: {
    validated: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.toValidate = val;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {},
});
